import {defineAsyncComponent} from 'vue';

const popupDashboardParamReceiptExpense = defineAsyncComponent(() =>
  import('@/views/dashboard/dashboardParamReceiptExpense/DashboardParamReceiptExpense.vue'),
);

const popupDashboardParamBudgetPlan = defineAsyncComponent(() =>
  import('@/views/dashboard/dashboardParamBudgetPlan/DashboardParamBudgetPlan.vue'),
);

const popupZoomOutDashboard = defineAsyncComponent(() =>
  import('@/views/dashboard/zoomOutDashboard/ZoomOutDashboard.vue'),
);

const popupViewDetailCashDeposit = defineAsyncComponent(() =>
  import('@/views/dashboard/viewDetailCashDeposit/ViewDetailCashDeposit.vue'),
);

export function registerDashboardPopup(app) {
  app.component('DashboardParamReceiptExpense', popupDashboardParamReceiptExpense);
  app.component('DashboardParamBudgetPlan', popupDashboardParamBudgetPlan );
  app.component('ZoomOutDasshboard', popupZoomOutDashboard);
  app.component('ViewDetailCashDeposit', popupViewDetailCashDeposit);
}
